import {withTranslation} from "react-i18next";
import React from "react";
import BackendConnectionService from "../../../ports/backend/backendConnectionService";
import ResponseProcessorService from "../../../ports/backend/ResponseProcessorService";
import LocalStorageService from "../../../ports/localStorage/localStorageService";
import Toastify from "../../alerts/Toastify";
import Swal from 'sweetalert2'
import {toast} from "react-toastify";

class RecogerDNI extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dni: "",
            disabled: false
        }
    }

    updateDNI(e) {
        this.setState({
            dni: e.target.value
        });
    }

    enableButton() {
        this.setState({
            dni: "",
            disabled: false
        });
    }

    disableButton() {
        this.setState({
            disabled: true
        });
    }

    markRegistry() {
        let registry = this.state.dni;
        let token = LocalStorageService.getUserToken();
        this.disableButton();
        Swal.fire({
            title: 'Confirmación',
            text: "Está a punto de marcar el DNI " + registry + " como recogido ¿Está seguro?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Recoger DNI',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                BackendConnectionService.markDNI(token, registry)
                    .then(() => {
                        Toastify.success(toast, "Se ha actualizado el registro correctamente");
                    }).catch((err) => {
                    ResponseProcessorService.processError(err);
                }).finally(() => {
                    this.enableButton();
                });
            }
        })
    }

    render() {
        let disabled = this.state.disabled;
        let text = "Recoger DNI"
        if(disabled) text = "Procesando...";
        return (
            <div className="col-lg-12">
                <div className="form-group mb-4">
                    <label htmlFor="acceso">DNI</label>
                    <input type="text" className="form-control" id="acceso" onChange={(e) => this.updateDNI(e)}
                           placeholder="99999999" value={this.state.dni} />
                </div>
                <div className="mt-4">
                    <button
                        className="btn btn-success btn-block waves-effect waves-light"
                        type="button" onClick={() => this.markRegistry()} disabled={disabled}>{text}
                    </button>
                </div>
            </div>
        );
    }
}
export default withTranslation()(RecogerDNI);